import { forwardRef, PropsWithChildren } from 'react';
import style from './profile-button.module.css';
import { Icon } from '../../../symbols';
import { getIcon } from '../../utils/get-icon';
import { ProfileType } from '@lhb/api/engagement-gateway/index';
import { cn } from '../../../../utils';

type ProfileSelectorProps = PropsWithChildren<{
  id: string;
  isOpen: boolean;
  type?: ProfileType;
  onClick?: () => void;
}>;

export const ProfileButton = forwardRef<
  HTMLButtonElement,
  ProfileSelectorProps
>(({ id, children, onClick, isOpen, type = ProfileType.PERSONAL }, ref) => {
  return (
    <>
      <button
        aria-haspopup="menu"
        ref={ref}
        id={id}
        onClick={onClick}
        className={cn(style.element, isOpen && 'active')}
        type="button"
      >
        <Icon name={getIcon(type)} size="1rem" />
        <span>{children}</span>
        <Icon name="chevron-down" className={style.chevron} />
      </button>
    </>
  );
});
